<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="card">
      <div v-if="this.is_authorization === null" class="card-body">
        <div class="d-flex justify-content-center">
          authorization checking...
        </div>
      </div>
      <div v-if="this.is_authorization === 'N'" class="card-body">
        <div class="d-flex justify-content-center">
          You do not have authorization for this page
        </div>
      </div>

      <div v-if="this.is_authorization === 'Y'" class="card-body">

        <!-- Loading state -->
        <div v-if="is_loading === 'Y'" class="d-flex justify-content-center py-5">
          <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
        </div>

        <div v-if="is_loading === 'N' && eventForm.event_key">

          <div class="card mb-4">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>แก้ไขข้อมูลกิจกรรม: <a target="_blank" :href="'../../' + eventForm.event_key">{{ eventForm.title }}</a></b></h5>
                <div class="d-flex gap-2">
                  <a :href="'/dashboard-organizer/' + eventForm.event_key" class="btn btn-outline-secondary">
                    <vue-feather type="arrow-left" size="16"></vue-feather> กลับหน้ารายงาน
                  </a>
                  <button type="button" @click.prevent="save_event()" :disabled="is_saving === 'Y'" class="btn btn-primary">
                    <span v-if="is_saving === 'Y'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    <vue-feather v-else type="save" size="16"></vue-feather>
                    บันทึกข้อมูล
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- ข้อมูลทั่วไป -->
          <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0"><b>ข้อมูลทั่วไป</b></h5>
              <div class="d-flex align-items-center gap-1 text-muted" style="font-size:0.85rem;">
                <vue-feather type="eye" size="15"></vue-feather>
                <span>{{ eventForm.view_count != null ? Number(eventForm.view_count).toLocaleString() : '0' }} views</span>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-12">
                  <label class="form-label">ชื่อกิจกรรม <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="eventForm.title" required />
                </div>
                <div class="col-md-12">
                  <label class="form-label">คำอธิบายสั้น (description)</label>
                  <input type="text" class="form-control" v-model="eventForm.description" maxlength="255" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">วันที่จัดกิจกรรม (dd/MM/yyyy) <span class="text-danger">*</span></label>
                  <input type="date" class="form-control" v-model="eventForm.event_date" required />
                  <small v-if="eventForm.event_date" class="text-muted">{{ formatDateDisplay(eventForm.event_date) }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">วันที่เปิดรับสมัคร (dd/MM/yyyy HH:mm)</label>
                  <div class="row g-2">
                    <div class="col-7">
                      <input type="date" class="form-control" v-model="registrationStartDate" @input="onRegistrationStartChange" />
                    </div>
                    <div class="col-5">
                      <input type="time" class="form-control" v-model="registrationStartTime" @input="onRegistrationStartChange" step="60" lang="en-GB" placeholder="HH:mm" />
                    </div>
                  </div>
                  <small v-if="eventForm.registration_start" class="text-muted">{{ formatDatetimeDisplay(eventForm.registration_start) }}</small>
                  <small class="text-muted d-block">รูปแบบเวลา 24 ชั่วโมง</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">วันที่ปิดรับสมัคร (dd/MM/yyyy HH:mm)</label>
                  <div class="row g-2">
                    <div class="col-7">
                      <input type="date" class="form-control" v-model="registrationEndDate" @input="onRegistrationEndChange" />
                    </div>
                    <div class="col-5">
                      <input type="time" class="form-control" v-model="registrationEndTime" @input="onRegistrationEndChange" step="60" lang="en-GB" placeholder="HH:mm" />
                    </div>
                  </div>
                  <small v-if="eventForm.registration_end" class="text-muted">{{ formatDatetimeDisplay(eventForm.registration_end) }}</small>
                  <small class="text-muted d-block">รูปแบบเวลา 24 ชั่วโมง</small>
                </div>
                <div class="col-md-6">
                  <label class="form-label">สถานที่จัดงาน (location)</label>
                  <input type="text" class="form-control" v-model="eventForm.location" maxlength="100" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">ภูมิภาค (regions)</label>
                  <select class="form-select" v-model="eventForm.regions">
                    <option value="">-- เลือกภูมิภาค --</option>
                    <option value="NORTH">NORTH (ภาคเหนือ)</option>
                    <option value="CENTER">CENTER (ภาคกลาง/กรุงเทพ)</option>
                    <option value="SOUTH">SOUTH (ภาคใต้)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เว็บไซต์ (website)</label>
                  <input type="url" class="form-control" v-model="eventForm.website" maxlength="100" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">สถานะกิจกรรม (event_status)</label>
                  <select class="form-select" v-model="eventForm.event_status">
                    <option value="OPEN">OPEN (เปิดรับสมัคร)</option>
                    <option value="ACTIVE">ACTIVE (ใช้งาน)</option>
                    <option value="SOON">SOON (เร็วๆ นี้)</option>
                    <option value="END">END (จบแล้ว)</option>
                    <option value="HIDE">HIDE (ซ่อน)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เปิดรับสมัคร (is_open_register)</label>
                  <select class="form-select" v-model="eventForm.is_open_register">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ลำดับการแสดง (sequence)</label>
                  <input type="number" class="form-control" v-model="eventForm.sequence" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">โหมดโปรดักชัน (is_production_mode)</label>
                  <select class="form-select" v-model="eventForm.is_production_mode">
                    <option value="Y">Y (Production)</option>
                    <option value="N">N (Test/Dev)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- อัปโหลดรูปภาพ (Drag & Drop) -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>อัปโหลดรูปภาพ</b></h5>
            </div>
            <div class="card-body">
              <div
                class="upload-dropzone"
                :class="{ 'drag-over': isDragging, 'upload-error': uploadError }"
                @dragenter.prevent="isDragging = true"
                @dragover.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false"
                @drop.prevent="onDrop"
                @click="$refs.fileInput.click()"
                style="
                  border: 2px dashed #adb5bd;
                  border-radius: 8px;
                  padding: 40px 20px;
                  text-align: center;
                  cursor: pointer;
                  transition: background 0.2s, border-color 0.2s;
                  background: #f8f9fa;
                "
                :style="isDragging ? 'background:#e9f5ff; border-color:#0d6efd;' : ''"
              >
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  multiple
                  style="display:none"
                  @change="onFileChange"
                />
                <div v-if="!isUploading">
                  <vue-feather type="upload-cloud" size="40" class="text-muted mb-2"></vue-feather>
                  <p class="mb-1 text-muted">ลากและวางรูปภาพที่นี่ หรือคลิกเพื่อเลือกไฟล์ได้หลายไฟล์</p>
                  <small class="text-muted">รองรับ JPG, PNG, GIF, WEBP</small>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center gap-2">
                  <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
                  <span class="text-primary">กำลังอัปโหลด...</span>
                </div>
              </div>

              <!-- Upload Error -->
              <div v-if="uploadError" class="alert alert-danger mt-2 py-2 mb-0">
                <small>{{ uploadError }}</small>
              </div>

              <!-- Upload Result -->
              <div v-if="uploadedFiles.length" class="mt-3 p-3 border rounded bg-light">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <vue-feather type="check-circle" size="16" class="text-success"></vue-feather>
                  <small class="text-success fw-semibold">อัปโหลดสำเร็จ {{ uploadedFiles.length }} ไฟล์</small>
                </div>
                <div class="d-grid gap-2">
                  <div v-for="item in uploadedFiles" :key="item.path + item.url" class="p-2 border rounded bg-white">
                    <div class="d-flex align-items-start justify-content-between gap-2 mb-1">
                      <div>
                        <div class="fw-semibold small">{{ item.name }}</div>
                        <small class="text-muted">Path: {{ item.path }}</small>
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary flex-shrink-0"
                        @click="copyUploadedText(item.url, item.name)"
                        :title="copiedUploadText === item.url ? 'คัดลอกแล้ว!' : 'คัดลอก URL'"
                      >
                        <vue-feather :type="copiedUploadText === item.url ? 'check' : 'copy'" size="14"></vue-feather>
                        {{ copiedUploadText === item.url ? 'คัดลอกแล้ว' : 'คัดลอก' }}
                      </button>
                    </div>
                    <code class="d-block text-break" style="font-size:0.78rem; word-break:break-all;">{{ item.url }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- URL รูปภาพ -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>รูปภาพ</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-10">
                  <label class="form-label">URL รูปหน้าปก (coverurl)</label>
                  <input type="url" class="form-control" v-model="eventForm.coverurl" maxlength="255" />
                </div>
                <div class="col-md-2 d-flex align-items-end">
                  <img v-if="eventForm.coverurl" :src="eventForm.coverurl" class="img-thumbnail" style="max-height: 60px;" />
                </div>
              </div>
            </div>
          </div>

          <!-- เนื้อหากิจกรรม -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>เนื้อหากิจกรรม</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-12">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="form-label mb-1">เนื้อหา (ภาษาไทย)</label>
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="downloadThaiContentHtml">
                      <vue-feather type="download" size="14"></vue-feather> Download .html
                    </button>
                  </div>
                  <textarea class="form-control" v-model="eventForm.content" rows="12"></textarea>
                </div>
                <div class="col-md-12">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <label class="form-label mb-0">เนื้อหา (English)</label>
                    <button type="button" class="btn btn-outline-secondary btn-sm py-0 px-2" @click="syncThaiContentToEnglish">
                      <vue-feather type="refresh-cw" size="12"></vue-feather> Sync
                    </button>
                  </div>
                  <textarea class="form-control" v-model="eventForm.content_en" rows="12"></textarea>
                </div>
                <div class="col-md-12">
                  <label class="form-label">ข้อมูลผู้จัดงาน (organizer_info)</label>
                  <textarea class="form-control" v-model="eventForm.organizer_info" rows="4"></textarea>
                </div>
                <div class="col-md-12">
                  <label class="form-label">ข้อมูลผู้จัดงาน (organizer_info_en)</label>
                  <textarea class="form-control" v-model="eventForm.organizer_info_en" rows="4"></textarea>
                </div>
                <div class="col-md-12">
                  <label class="form-label">เงื่อนไขการสมัคร (condition)</label>
                  <textarea class="form-control" v-model="eventForm.condition" rows="4"></textarea>
                </div>
                <div class="col-md-12">
                  <label class="form-label">เงื่อนไขการสมัคร EN (condition_en)</label>
                  <textarea class="form-control" v-model="eventForm.condition_en" rows="4"></textarea>
                </div>
                <div class="col-md-12">
                  <label class="form-label">ข้อความหลังสมัครสำเร็จ (txt_message_registed)</label>
                  <input type="text" class="form-control" v-model="eventForm.txt_message_registed" maxlength="1000" />
                  <small class="text-muted">ตัวแปร: {COUNT_RUNNER}, {COUNT_RUNNER_BY_TYPE}, {TYPE_NAME}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- การชำระเงิน -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>การชำระเงิน</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">วิธีชำระเงิน (payment_method)</label>
                  <select class="form-select" v-model="eventForm.payment_method">
                    <option value="DIRECT">DIRECT (โอนเงิน)</option>
                    <option value="OPN">OPN (Online Payment)</option>
                    <option value="FREE">FREE (ฟรี)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ค่าธรรมเนียม % (payment_fee)</label>
                  <input type="number" step="0.01" class="form-control" v-model="eventForm.payment_fee" maxlength="10" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">ฟรีค่าธรรมเนียม (is_free_payment_fee)</label>
                  <select class="form-select" v-model="eventForm.is_free_payment_fee">
                    <option value="Y">Y (ฟรี)</option>
                    <option value="N">N (มีค่าธรรมเนียม)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เปิดคูปอง (is_coupon)</label>
                  <select class="form-select" v-model="eventForm.is_coupon">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">ชื่อบัญชี (payment_account_name)</label>
                  <input type="text" class="form-control" v-model="eventForm.payment_account_name" maxlength="100" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">เลขบัญชี (payment_account_no)</label>
                  <input type="text" class="form-control" v-model="eventForm.payment_account_no" maxlength="100" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">ธนาคาร (payment_bank_name)</label>
                  <input type="text" class="form-control" v-model="eventForm.payment_bank_name" maxlength="100" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">QR Code สแกน (is_qrcode_scan)</label>
                  <select class="form-select" v-model="eventForm.is_qrcode_scan">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-9">
                  <label class="form-label">URL QR Code (qrcode_scan_url)</label>
                  <input type="url" class="form-control" v-model="eventForm.qrcode_scan_url" maxlength="200" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">ค่าธรรมเนียมระบบ (is_system_fee)</label>
                  <select class="form-select" v-model="eventForm.is_system_fee">
                    <option value="Y">Y (มี)</option>
                    <option value="N">N (ไม่มี)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">จำนวนค่าธรรมเนียมระบบ (system_fee_amt)</label>
                  <input type="number" step="0.01" class="form-control" v-model="eventForm.system_fee_amt" />
                </div>
              </div>
            </div>
          </div>

          <!-- การจำกัดผู้สมัคร -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>การจำกัดและข้อกำหนดผู้สมัคร</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">จำกัดจำนวน (is_limit_participate)</label>
                  <select class="form-select" v-model="eventForm.is_limit_participate">
                    <option value="Y">Y (จำกัด)</option>
                    <option value="N">N (ไม่จำกัด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">จำนวนสูงสุด (limit_participate)</label>
                  <input type="number" class="form-control" v-model="eventForm.limit_participate" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">จำนวนสมัครสูงสุด/ออเดอร์ (max_runner_register_per_order)</label>
                  <input type="number" class="form-control" v-model="eventForm.max_runner_register_per_order" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">คำนวณอายุ (cal_age_method)</label>
                  <select class="form-select" v-model="eventForm.cal_age_method">
                    <option value="RACE_YEAR">RACE_YEAR (ปีที่จัดงาน)</option>
                    <option value="RACE_DATE">RACE_DATE (วันที่จัดงาน)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ตรวจสอบ Email (validate_email)</label>
                  <select class="form-select" v-model="eventForm.validate_email">
                    <option value="Y">Y (ตรวจสอบ)</option>
                    <option value="N">N (ไม่ตรวจสอบ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ต้องการเลขบัตร (is_require_id_card)</label>
                  <select class="form-select" v-model="eventForm.is_require_id_card">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">โหมดวิ่ง (is_run_model)</label>
                  <select class="form-select" v-model="eventForm.is_run_model">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ผู้จัดแก้ไขประเภท (is_organizer_can_change_run_type)</label>
                  <select class="form-select" v-model="eventForm.is_organizer_can_change_run_type">
                    <option value="Y">Y (ได้)</option>
                    <option value="N">N (ไม่ได้)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- ข้อมูลที่บังคับกรอก -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>ข้อมูลที่บังคับกรอก</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">ประวัติสุขภาพ (is_require_health_problem)</label>
                  <select class="form-select" v-model="eventForm.is_require_health_problem">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">กรุ๊ปเลือด (is_require_blood_group)</label>
                  <select class="form-select" v-model="eventForm.is_require_blood_group">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ชื่อผู้ติดต่อฉุกเฉิน (is_require_emergency_name)</label>
                  <select class="form-select" v-model="eventForm.is_require_emergency_name">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ความสัมพันธ์ฉุกเฉิน (is_require_emergency_relation)</label>
                  <select class="form-select" v-model="eventForm.is_require_emergency_relation">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เบอร์ฉุกเฉิน (is_require_emergency_mobile_no)</label>
                  <select class="form-select" v-model="eventForm.is_require_emergency_mobile_no">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- ฟังก์ชันเพิ่มเติม -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>ฟังก์ชันเพิ่มเติม</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">เพิ่มเติม 1 (is_additional)</label>
                  <select class="form-select" v-model="eventForm.is_additional">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เพิ่มเติม 1.1 (is_additional1)</label>
                  <select class="form-select" v-model="eventForm.is_additional1">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">บังคับ 1.1 (is_additional1_require)</label>
                  <select class="form-select" v-model="eventForm.is_additional1_require">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                  <label class="form-label">เพิ่มเติม 2 (is_additional2)</label>
                  <select class="form-select" v-model="eventForm.is_additional2">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">บังคับ 2 (is_additional2_require)</label>
                  <select class="form-select" v-model="eventForm.is_additional2_require">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เพิ่มเติม 3 (is_additional3)</label>
                  <select class="form-select" v-model="eventForm.is_additional3">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">บังคับ 3 (is_additional3_require)</label>
                  <select class="form-select" v-model="eventForm.is_additional3_require">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เพิ่มเติม 4 (is_additional4)</label>
                  <select class="form-select" v-model="eventForm.is_additional4">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">บังคับ 4 (is_additional4_require)</label>
                  <select class="form-select" v-model="eventForm.is_additional4_require">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ฟังก์ชัน CheckBIB (is_enable_checkbib_function)</label>
                  <select class="form-select" v-model="eventForm.is_enable_checkbib_function">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">คืนเงิน (is_enable_refund)</label>
                  <select class="form-select" v-model="eventForm.is_enable_refund">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">กิจกรรมในรูปแบบตรวจสอบรายชื่อ จะไปดึงข้อมูลจาก table event_participant (is_participant_check)</label>
                  <select class="form-select" v-model="eventForm.is_participant_check">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">เปิดตรวจสอบข้อมูลผู้เข้าร่วม (is_open_participate_check)</label>
                  <select class="form-select" v-model="eventForm.is_open_participate_check">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- Custom Field 1 -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>Custom Field</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">Custom Field 1 (is_custom_field1)</label>
                  <select class="form-select" v-model="eventForm.is_custom_field1">
                    <option value="Y">Y (เปิด)</option>
                    <option value="N">N (ปิด)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">บังคับกรอก (is_custom_field1_require)</label>
                  <select class="form-select" v-model="eventForm.is_custom_field1_require">
                    <option value="Y">Y (บังคับ)</option>
                    <option value="N">N (ไม่บังคับ)</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">ชื่อ Field (ภาษาไทย)</label>
                  <input type="text" class="form-control" v-model="eventForm.is_custom_field1_name" maxlength="100" />
                </div>
                <div class="col-md-3">
                  <label class="form-label">ชื่อ Field (English)</label>
                  <input type="text" class="form-control" v-model="eventForm.is_custom_field1_name_en" maxlength="100" />
                </div>
              </div>
            </div>
          </div>

          <!-- spacial_config -->
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="m-0"><b>Spacial Config (JSON)</b></h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-12">
                  <label class="form-label">spacial_config</label>
                  <textarea class="form-control" v-model="eventForm.spacial_config" rows="5" style="font-family: monospace;"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- ปุ่มบันทึกด้านล่าง -->
          <div class="d-flex justify-content-end gap-2 mb-4">
            <a :href="'/dashboard-organizer/' + eventForm.event_key" class="btn btn-outline-secondary">
              <vue-feather type="arrow-left" size="16"></vue-feather> กลับหน้ารายงาน
            </a>
            <button type="button" @click.prevent="save_event()" :disabled="is_saving === 'Y'" class="btn btn-primary">
              <span v-if="is_saving === 'Y'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              <vue-feather v-else type="save" size="16"></vue-feather>
              บันทึกข้อมูล
            </button>
          </div>

          <!-- ประเภทการแข่งขัน -->
          <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0"><b>ประเภทการแข่งขัน</b></h5>
              <button type="button" class="btn btn-success btn-sm" @click="open_add_run_type()">
                <vue-feather type="plus" size="14"></vue-feather> เพิ่มประเภท
              </button>
            </div>
            <div class="card-body p-0">
              <div v-if="isLoadingRunTypes" class="d-flex justify-content-center align-items-center gap-2 py-4">
                <span class="spinner-border spinner-border-sm"></span> กำลังโหลด...
              </div>
              <div v-else class="table-responsive">
                <table class="table table-bordered table-hover mb-0" style="font-size:0.85rem;">
                  <thead class="table-light">
                    <tr>
                      <th style="width:50px" class="text-center">ลำดับ</th>
                      <th>ชื่อประเภท</th>
                      <th>คำอธิบาย</th>
                      <th class="text-end">ราคา</th>
                      <th>เริ่มโปรโมชั่น</th>
                      <th>สิ้นสุดโปรโมชั่น</th>
                      <th class="text-end">สล็อต</th>
                      <th class="text-center" style="width:110px">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!runTypeList.length">
                      <td colspan="8" class="text-center text-muted py-3">ยังไม่มีข้อมูลประเภทการแข่งขัน</td>
                    </tr>
                    <tr v-for="item in runTypeList" :key="item.id">
                      <td class="text-center">{{ item.seq }}</td>
                      <td><b>{{ item.name }}</b></td>
                      <td><small class="text-muted">{{ item.description }}</small></td>
                      <td class="text-end">{{ item.price != null ? Number(item.price).toLocaleString() : '-' }}</td>
                      <td>
                        <small :class="getPromotionTextClass(item)">
                          {{ formatPromotionDisplayText(item.price_promotion_start, item) }}
                        </small>
                      </td>
                      <td>
                        <small :class="getPromotionTextClass(item)">
                          {{ formatPromotionDisplayText(item.price_promotion_end, item) }}
                        </small>
                      </td>
                      <td class="text-end">{{ item.slots_target != null ? Number(item.slots_target).toLocaleString() : '-' }}</td>
                      <td class="text-center">
                        <div class="d-flex gap-1 justify-content-center">
                          <button type="button" class="btn btn-outline-primary btn-sm py-0 px-1" @click="open_edit_run_type(item)" title="แก้ไข">
                            <vue-feather type="edit-2" size="13"></vue-feather>
                          </button>
                          <button type="button" class="btn btn-outline-info btn-sm py-0 px-1" @click="copy_run_type(item)" title="คัดลอก">
                            <vue-feather type="copy" size="13"></vue-feather>
                          </button>
                          <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" @click="delete_run_type(item)" title="ลบ">
                            <vue-feather type="trash-2" size="13"></vue-feather>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Modal ประเภทการแข่งขัน -->
          <div v-if="showRunTypeModal"
            style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;">
            <div class="card mb-0" style="width:100%;max-width:620px;max-height:90vh;overflow-y:auto;">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h6 class="m-0"><b>{{ isEditRunType ? 'แก้ไข' : 'เพิ่ม' }}ประเภทการแข่งขัน</b></h6>
                <button type="button" class="btn-close" @click="showRunTypeModal = false"></button>
              </div>
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-8">
                    <label class="form-label">ชื่อประเภท <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="runTypeForm.name" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">ลำดับ (seq)<span class="text-danger">*</span></label>
                    <input type="number" class="form-control" v-model="runTypeForm.seq" />
                  </div>
                  <div class="col-md-12">
                    <label class="form-label">คำอธิบาย (description) เช่น เสื้อ,บิบ,เหรียญ<span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="runTypeForm.description" maxlength="200" />
                  </div>
                  <div class="col-md-12">
                    <label class="form-label">รูปแบบการวิ่ง ID list <small class="text-muted">(events_run_model_id_list) เช่น 1,3</small></label>
                    <input type="text" class="form-control" v-model="runTypeForm.events_run_model_id_list" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ราคา (price)<span class="text-danger">*</span></label>
                    <input type="number" step="0.01" class="form-control" v-model="runTypeForm.price" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ราคาโปรโมชั่น (price_promotion)</label>
                    <input type="number" step="0.01" class="form-control" v-model="runTypeForm.price_promotion" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">เริ่มโปรโมชั่น (price_promotion_start)<span class="text-danger">*</span></label>
                    <input type="datetime-local" class="form-control" v-model="runTypeForm.price_promotion_start" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">สิ้นสุดโปรโมชั่น (price_promotion_end)<span class="text-danger">*</span></label>
                    <input type="datetime-local" class="form-control" v-model="runTypeForm.price_promotion_end" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">จำนวนที่รับ (slots_target)</label>
                    <input type="number" class="form-control" v-model="runTypeForm.slots_target" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">เป็นทีม (is_team)</label>
                    <select class="form-select" v-model="runTypeForm.is_team">
                      <option value="N">N (ไม่ใช่ทีม)</option>
                      <option value="Y">Y (ทีม)</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">จำนวนสมาชิกทีม (team_member)</label>
                    <input type="number" class="form-control" v-model="runTypeForm.team_member" :disabled="runTypeForm.is_team === 'N'" />
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary" @click="showRunTypeModal = false">ยกเลิก</button>
                <button type="button" class="btn btn-primary" @click="save_run_type()" :disabled="isSavingRunType">
                  <span v-if="isSavingRunType" class="spinner-border spinner-border-sm me-1"></span>
                  <vue-feather v-else type="save" size="14"></vue-feather>
                  บันทึก
                </button>
              </div>
            </div>
          </div>

          <!-- ขนาดเสื้อ -->
          <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0"><b>ขนาดเสื้อ</b></h5>
              <button type="button" class="btn btn-success btn-sm" @click="open_add_t_shirt()">
                <vue-feather type="plus" size="14"></vue-feather> เพิ่มขนาดเสื้อ
              </button>
            </div>
            <div class="card-body p-0">
              <div v-if="isLoadingTShirts" class="d-flex justify-content-center align-items-center gap-2 py-4">
                <span class="spinner-border spinner-border-sm"></span> กำลังโหลด...
              </div>
              <div v-else class="table-responsive">
                <table class="table table-bordered table-hover mb-0" style="font-size:0.85rem;">
                  <thead class="table-light">
                    <tr>
                      <th style="width:50px" class="text-center">ลำดับ</th>
                      <th>ชื่อขนาด</th>
                      <th class="text-end">ราคาเพิ่มเติม</th>
                      <th class="text-center">run_type_id</th>
                      <th class="text-center" style="width:110px">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!tShirtList.length">
                      <td colspan="5" class="text-center text-muted py-3">ยังไม่มีข้อมูลขนาดเสื้อ</td>
                    </tr>
                    <tr v-for="item in tShirtList" :key="item.id">
                      <td class="text-center">{{ item.seq }}</td>
                      <td><b>{{ item.name }}</b></td>
                      <td class="text-end">{{ item.additional_price ? Number(item.additional_price).toLocaleString() : '-' }}</td>
                      <td class="text-center"><small class="text-muted">{{ item.run_type_id || '-' }}</small></td>
                      <td class="text-center">
                        <div class="d-flex gap-1 justify-content-center">
                          <button type="button" class="btn btn-outline-primary btn-sm py-0 px-1" @click="open_edit_t_shirt(item)" title="แก้ไข">
                            <vue-feather type="edit-2" size="13"></vue-feather>
                          </button>
                          <button type="button" class="btn btn-outline-info btn-sm py-0 px-1" @click="copy_t_shirt(item)" title="คัดลอก">
                            <vue-feather type="copy" size="13"></vue-feather>
                          </button>
                          <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" @click="delete_t_shirt(item)" title="ลบ">
                            <vue-feather type="trash-2" size="13"></vue-feather>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Modal ขนาดเสื้อ -->
          <div v-if="showTShirtModal"
            style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;">
            <div class="card mb-0" style="width:100%;max-width:440px;max-height:90vh;overflow-y:auto;">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h6 class="m-0"><b>{{ isEditTShirt ? 'แก้ไข' : 'เพิ่ม' }}ขนาดเสื้อ</b></h6>
                <button type="button" class="btn-close" @click="showTShirtModal = false"></button>
              </div>
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-8">
                    <label class="form-label">ชื่อขนาดเสื้อ <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="tShirtForm.name" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">ลำดับ (seq)</label>
                    <input type="number" class="form-control" v-model="tShirtForm.seq" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ราคาเพิ่มเติม (additional_price)</label>
                    <input type="number" class="form-control" v-model="tShirtForm.additional_price" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ประเภทการแข่งขัน (run_type_id) <small class="text-muted">0 = ทุกประเภท</small></label>
                    <input type="number" class="form-control" v-model="tShirtForm.run_type_id" />
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary" @click="showTShirtModal = false">ยกเลิก</button>
                <button type="button" class="btn btn-primary" @click="save_t_shirt()" :disabled="isSavingTShirt">
                  <span v-if="isSavingTShirt" class="spinner-border spinner-border-sm me-1"></span>
                  <vue-feather v-else type="save" size="14"></vue-feather>
                  บันทึก
                </button>
              </div>
            </div>
          </div>

          <!-- ช่องทางการจัดส่ง -->
          <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0"><b>ช่องทางการจัดส่ง</b></h5>
              <button type="button" class="btn btn-success btn-sm" @click="open_add_delivery()">
                <vue-feather type="plus" size="14"></vue-feather> เพิ่มช่องทาง
              </button>
            </div>
            <div class="card-body p-0">
              <div v-if="isLoadingDelivery" class="d-flex justify-content-center align-items-center gap-2 py-4">
                <span class="spinner-border spinner-border-sm"></span> กำลังโหลด...
              </div>
              <div v-else class="table-responsive">
                <table class="table table-bordered table-hover mb-0" style="font-size:0.85rem;">
                  <thead class="table-light">
                    <tr>
                      <th style="width:50px" class="text-center">ลำดับ</th>
                      <th>ชื่อ (TH)</th>
                      <th>ชื่อ (EN)</th>
                      <th class="text-end">ราคา</th>
                      <th class="text-end">ราคาเพิ่ม</th>
                      <th class="text-center">บังคับที่อยู่</th>
                      <th class="text-center" style="width:110px">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!deliveryList.length">
                      <td colspan="7" class="text-center text-muted py-3">ยังไม่มีข้อมูลช่องทางการจัดส่ง</td>
                    </tr>
                    <tr v-for="item in deliveryList" :key="item.id">
                      <td class="text-center">{{ item.seq }}</td>
                      <td><b>{{ item.name }}</b><br><small class="text-muted">{{ item.description }}</small></td>
                      <td><span>{{ item.name_en }}</span><br><small class="text-muted">{{ item.description_en }}</small></td>
                      <td class="text-end">{{ item.price != null ? Number(item.price).toLocaleString() : '-' }}</td>
                      <td class="text-end">{{ item.price_additional ? Number(item.price_additional).toLocaleString() : '-' }}</td>
                      <td class="text-center">
                        <span :class="item.is_require_address === 'Y' ? 'badge bg-warning text-dark' : 'badge bg-secondary'">{{ item.is_require_address }}</span>
                      </td>
                      <td class="text-center">
                        <div class="d-flex gap-1 justify-content-center">
                          <button type="button" class="btn btn-outline-primary btn-sm py-0 px-1" @click="open_edit_delivery(item)" title="แก้ไข">
                            <vue-feather type="edit-2" size="13"></vue-feather>
                          </button>
                          <button type="button" class="btn btn-outline-info btn-sm py-0 px-1" @click="copy_delivery(item)" title="คัดลอก">
                            <vue-feather type="copy" size="13"></vue-feather>
                          </button>
                          <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" @click="delete_delivery(item)" title="ลบ">
                            <vue-feather type="trash-2" size="13"></vue-feather>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Modal ช่องทางการจัดส่ง -->
          <div v-if="showDeliveryModal"
            style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;">
            <div class="card mb-0" style="width:100%;max-width:580px;max-height:90vh;overflow-y:auto;">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h6 class="m-0"><b>{{ isEditDelivery ? 'แก้ไข' : 'เพิ่ม' }}ช่องทางการจัดส่ง</b></h6>
                <button type="button" class="btn-close" @click="showDeliveryModal = false"></button>
              </div>
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">ชื่อ (TH) เช่น<span class="text-danger">*</span><br/> - รับด้วยตนเอง<br/> - ใช้บริการจัดส่ง (50 บาท) </label>
                    <input type="text" class="form-control" v-model="deliveryForm.name" maxlength="100" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ชื่อ (EN)</label>
                    <input type="text" class="form-control" v-model="deliveryForm.name_en" maxlength="100" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">คำอธิบาย (TH) <span class="text-danger">*</span> เช่น<br /> - รับด้วยตนเอง: แจ้งสถานที่เวลาให้ทราบอีกครั้งหน้าเพจกิจกรรม<br /> - ใช้บริการจัดส่งโดยขนส่งเอกชน </label>
                    <input type="text" class="form-control" v-model="deliveryForm.description" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">คำอธิบาย (EN)</label>
                    <input type="text" class="form-control" v-model="deliveryForm.description_en" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">ราคา (price)</label>
                    <input type="number" step="0.01" class="form-control" v-model="deliveryForm.price" @input="onDeliveryPriceChange" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">ราคาเพิ่มเติม (price_additional)</label>
                    <input type="number" class="form-control" v-model="deliveryForm.price_additional" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">ลำดับ (seq)</label>
                    <input type="number" class="form-control" v-model="deliveryForm.seq" />
                  </div>
                  <div class="col-md-12">
                    <label class="form-label">บังคับกรอกที่อยู่ (is_require_address)</label>
                    <select class="form-select" v-model="deliveryForm.is_require_address" :disabled="Number(deliveryForm.price) > 0">
                      <option value="Y">Y (บังคับ)</option>
                      <option value="N">N (ไม่บังคับ)</option>
                    </select>
                    <small v-if="Number(deliveryForm.price) > 0" class="text-muted">เมื่อราคามากกว่า 0 จะบังคับกรอกที่อยู่ ('Y') โดยอัตโนมัติ</small>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary" @click="showDeliveryModal = false">ยกเลิก</button>
                <button type="button" class="btn btn-primary" @click="save_delivery()" :disabled="isSavingDelivery">
                  <span v-if="isSavingDelivery" class="spinner-border spinner-border-sm me-1"></span>
                  <vue-feather v-else type="save" size="14"></vue-feather>
                  บันทึก
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";

export default {
  components: {
    welcomecard,
  },
  data() {
    return {
      is_authorization: null,
      token: null,
      is_loading: "Y",
      is_saving: "N",
      isDragging: false,
      isUploading: false,
      uploadedFiles: [],
      uploadError: "",
      copiedUploadText: "",
      runTypeList: [],
      isLoadingRunTypes: false,
      showRunTypeModal: false,
      isEditRunType: false,
      isSavingRunType: false,
      runTypeForm: {
        id: null,
        name: "",
        description: "",
        events_run_model_id_list: "",
        price: 0,
        price_promotion: 0,
        price_promotion_start: "",
        price_promotion_end: "",
        slots_target: 500,
        seq: 1,
        is_team: "N",
        team_member: 0,
      },
      tShirtList: [],
      isLoadingTShirts: false,
      showTShirtModal: false,
      isEditTShirt: false,
      isSavingTShirt: false,
      tShirtForm: {
        id: null,
        name: "",
        seq: 1,
        run_type_id: 0,
        additional_price: 0,
      },
      deliveryList: [],
      isLoadingDelivery: false,
      showDeliveryModal: false,
      isEditDelivery: false,
      isSavingDelivery: false,
      deliveryForm: {
        id: null,
        name: "",
        name_en: "",
        description: "",
        description_en: "",
        is_require_address: "N",
        price: 0,
        seq: 1,
        price_additional: 0,
      },
      eventForm: {
        event_key: "",
        title: "",
        description: "",
        event_date: "",
        registration_start: "",
        registration_end: "",
        location: "",
        regions: "",
        website: "",
        event_status: "ACTIVE",
        is_open_register: "Y",
        sequence: null,
        is_production_mode: "Y",
        coverurl: "",
        content: "",
        content_en: "",
        organizer_info: "",
        organizer_info_en: "",
        condition: "",
        condition_en: "",
        txt_message_registed: "",
        payment_method: "DIRECT",
        payment_fee: "0.03",
        is_free_payment_fee: "N",
        is_coupon: "N",
        payment_account_name: "",
        payment_account_no: "",
        payment_bank_name: "",
        is_qrcode_scan: "N",
        qrcode_scan_url: "",
        is_system_fee: "N",
        system_fee_amt: 0,
        is_limit_participate: "N",
        limit_participate: 2000,
        max_runner_register_per_order: 20,
        cal_age_method: "RACE_YEAR",
        validate_email: "Y",
        is_require_id_card: "Y",
        is_run_model: "Y",
        is_organizer_can_change_run_type: "N",
        is_require_health_problem: "N",
        is_require_blood_group: "Y",
        is_require_emergency_name: "Y",
        is_require_emergency_relation: "Y",
        is_require_emergency_mobile_no: "Y",
        is_additional: "N",
        is_additional1: "N",
        is_additional1_require: "N",
        is_additional2: "N",
        is_additional2_require: "N",
        is_additional3: "N",
        is_additional3_require: "N",
        is_additional4: "N",
        is_additional4_require: "N",
        is_enable_checkbib_function: "N",
        is_enable_refund: "N",
        is_participant_check: "N",
        is_open_participate_check: "N",
        view_count: 0,
        is_custom_field1: "N",
        is_custom_field1_require: "N",
        is_custom_field1_name: "",
        is_custom_field1_name_en: "",
        spacial_config: "",
      },
      registrationStartDate: "",
      registrationStartTime: "",
      registrationEndDate: "",
      registrationEndTime: "",
    };
  },
  async mounted() {
    window.addEventListener("keydown", this.handleEscKey);
    this.token = localStorage.getItem("_rr_token");
    if (this.token !== null) {
      await this.authorization();
      if (this.is_authorization === "Y") {
        await this.load_event_detail();
        await this.load_run_types();
        await this.load_t_shirts();
        await this.load_delivery();
      }
    } else {
      this.$router.push("/auth/login");
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEscKey);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleEscKey);
  },
  methods: {
    handleEscKey(event) {
      if (event.key !== "Escape") return;
      if (this.showDeliveryModal) {
        this.showDeliveryModal = false;
      }
      if (this.showTShirtModal) {
        this.showTShirtModal = false;
      }
      if (this.showRunTypeModal) {
        this.showRunTypeModal = false;
      }
    },
    onDrop(e) {
      this.isDragging = false;
      const files = Array.from(e.dataTransfer.files || []).filter((file) => file.type.startsWith("image/"));
      if (files.length) this.uploadFiles(files);
    },
    onFileChange(e) {
      const files = Array.from(e.target.files || []).filter((file) => file.type.startsWith("image/"));
      if (files.length) this.uploadFiles(files);
      e.target.value = "";
    },
    async uploadFiles(files) {
      this.uploadError = "";
      this.uploadedFiles = [];
      this.copiedUploadText = "";
      this.isUploading = true;
      const uploadedFiles = [];
      const errors = [];
      try {
        for (const file of files) {
          try {
            const result = await this.uploadSingleFile(file);
            uploadedFiles.push(result);
          } catch (error) {
            errors.push(file.name + ": " + error.message);
          }
        }
      } finally {
        this.uploadedFiles = uploadedFiles;
        if (errors.length) {
          this.uploadError = "อัปโหลดบางไฟล์ไม่สำเร็จ: " + errors.join(" | ");
        }
        this.isUploading = false;
      }
    },
    async uploadSingleFile(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("event_key", this.eventForm.event_key);
      formData.append("image_name", file.name);
      const headers = {
        Authorization: "Bearer " + this.token,
        "Content-Type": "multipart/form-data",
      };
      const res = await axios.post("v1/upload/event", formData, { headers });
      if (res.data.status === "success") {
        return {
          name: file.name,
          url: res.data.body.url,
          path: res.data.body.path,
        };
      }
      throw new Error(res.data.message || "อัปโหลดไม่สำเร็จ");
    },
    copyUploadedText(text) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        this.copiedUploadText = text;
        setTimeout(() => {
          if (this.copiedUploadText === text) {
            this.copiedUploadText = "";
          }
        }, 2000);
      });
    },
    async load_run_types() {
      this.isLoadingRunTypes = true;
      const headers = { Authorization: "Bearer " + this.token };
      try {
        const res = await axios.post("v1/organizer/event-edit-events-run-type/list", { event_key: this.$route.params.event_key }, { headers });
        if (res.data.status === "success") {
          this.runTypeList = res.data.body || [];
        }
      } catch (e) {
        this.runTypeList = [];
      }
      this.isLoadingRunTypes = false;
    },
    open_add_run_type() {
      this.isEditRunType = false;
      this.runTypeForm = {
        id: null, name: "", description: "", events_run_model_id_list: "",
        price: 0, price_promotion: 0, price_promotion_start: "", price_promotion_end: "",
        slots_target: 500, seq: this.runTypeList.length + 1, is_team: "N", team_member: 0,
      };
      this.showRunTypeModal = true;
    },
    open_edit_run_type(item) {
      this.isEditRunType = true;
      this.runTypeForm = {
        id: item.id,
        name: item.name || "",
        description: item.description || "",
        events_run_model_id_list: item.events_run_model_id_list || "",
        price: item.price || 0,
        price_promotion: item.price_promotion || 0,
        price_promotion_start: item.price_promotion_start ? item.price_promotion_start.slice(0, 16) : "",
        price_promotion_end: item.price_promotion_end ? item.price_promotion_end.slice(0, 16) : "",
        slots_target: item.slots_target || 500,
        seq: item.seq || 1,
        is_team: item.is_team || "N",
        team_member: item.team_member || 0,
      };
      this.showRunTypeModal = true;
    },
    copy_run_type(item) {
      this.isEditRunType = false;
      this.runTypeForm = {
        id: null,
        name: item.name + " (Copy)",
        description: item.description || "",
        events_run_model_id_list: item.events_run_model_id_list || "",
        price: item.price || 0,
        price_promotion: item.price_promotion || 0,
        price_promotion_start: item.price_promotion_start ? item.price_promotion_start.slice(0, 16) : "",
        price_promotion_end: item.price_promotion_end ? item.price_promotion_end.slice(0, 16) : "",
        slots_target: item.slots_target || 500,
        seq: this.runTypeList.length + 1,
        is_team: item.is_team || "N",
        team_member: item.team_member || 0,
      };
      this.showRunTypeModal = true;
    },
    async delete_run_type(item) {
      if (!confirm('ต้องการลบ "' + item.name + '" ใช่หรือไม่?')) return;
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/event-edit-events-run-type/delete", { event_key: this.$route.params.event_key, id: item.id }, { headers });
      if (res.data.status === "success") {
        await this.load_run_types();
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    async save_run_type() {
      if (!this.runTypeForm.name.trim()) { alert("กรุณากรอกชื่อประเภทการแข่งขัน"); return; }
      this.isSavingRunType = true;
      const headers = { Authorization: "Bearer " + this.token };
      const endpoint = this.isEditRunType
        ? "v1/organizer/event-edit-events-run-type/update"
        : "v1/organizer/event-edit-events-run-type/add";
      const res = await axios.post(endpoint, { ...this.runTypeForm, event_key: this.$route.params.event_key }, { headers });
      this.isSavingRunType = false;
      if (res.data.status === "success") {
        this.showRunTypeModal = false;
        await this.load_run_types();
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    async load_t_shirts() {
      this.isLoadingTShirts = true;
      const headers = { Authorization: "Bearer " + this.token };
      try {
        const res = await axios.post("v1/organizer/event-edit-runner-t-shirt/list", { event_key: this.$route.params.event_key }, { headers });
        if (res.data.status === "success") {
          this.tShirtList = res.data.body || [];
        }
      } catch (e) {
        this.tShirtList = [];
      }
      this.isLoadingTShirts = false;
    },
    open_add_t_shirt() {
      this.isEditTShirt = false;
      this.tShirtForm = { id: null, name: "", seq: this.tShirtList.length + 1, run_type_id: 0, additional_price: 0 };
      this.showTShirtModal = true;
    },
    open_edit_t_shirt(item) {
      this.isEditTShirt = true;
      this.tShirtForm = { id: item.id, name: item.name || "", seq: item.seq || 1, run_type_id: item.run_type_id || 0, additional_price: item.additional_price || 0 };
      this.showTShirtModal = true;
    },
    copy_t_shirt(item) {
      this.isEditTShirt = false;
      this.tShirtForm = { id: null, name: item.name + " (Copy)", seq: this.tShirtList.length + 1, run_type_id: item.run_type_id || 0, additional_price: item.additional_price || 0 };
      this.showTShirtModal = true;
    },
    async delete_t_shirt(item) {
      if (!confirm('ต้องการลบ "' + item.name + '" ใช่หรือไม่?')) return;
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/event-edit-runner-t-shirt/delete", { event_key: this.$route.params.event_key, id: item.id }, { headers });
      if (res.data.status === "success") {
        await this.load_t_shirts();
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    async save_t_shirt() {
      if (!this.tShirtForm.name.trim()) { alert("กรุณากรอกชื่อขนาดเสื้อ"); return; }
      this.isSavingTShirt = true;
      const headers = { Authorization: "Bearer " + this.token };
      const endpoint = this.isEditTShirt
        ? "v1/organizer/event-edit-runner-t-shirt/update"
        : "v1/organizer/event-edit-runner-t-shirt/add";
      const res = await axios.post(endpoint, { ...this.tShirtForm, event_key: this.$route.params.event_key }, { headers });
      this.isSavingTShirt = false;
      if (res.data.status === "success") {
        this.showTShirtModal = false;
        await this.load_t_shirts();
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    async load_delivery() {
      this.isLoadingDelivery = true;
      const headers = { Authorization: "Bearer " + this.token };
      try {
        const res = await axios.post("v1/organizer/event-edit-runner-delivery-type/list", { event_key: this.$route.params.event_key }, { headers });
        if (res.data.status === "success") {
          this.deliveryList = res.data.body || [];
        }
      } catch (e) {
        this.deliveryList = [];
      }
      this.isLoadingDelivery = false;
    },
    open_add_delivery() {
      this.isEditDelivery = false;
      this.deliveryForm = { id: null, name: "", name_en: "", description: "", description_en: "", is_require_address: "N", price: 0, seq: this.deliveryList.length + 1, price_additional: 0 };
      this.showDeliveryModal = true;
    },
    open_edit_delivery(item) {
      this.isEditDelivery = true;
      this.deliveryForm = {
        id: item.id,
        name: item.name || "",
        name_en: item.name_en || "",
        description: item.description || "",
        description_en: item.description_en || "",
        is_require_address: item.is_require_address || "N",
        price: item.price || 0,
        seq: item.seq || 1,
        price_additional: item.price_additional || 0,
      };
      this.onDeliveryPriceChange();
      this.showDeliveryModal = true;
    },
    copy_delivery(item) {
      this.isEditDelivery = false;
      this.deliveryForm = {
        id: null,
        name: item.name + " (Copy)",
        name_en: item.name_en || "",
        description: item.description || "",
        description_en: item.description_en || "",
        is_require_address: item.is_require_address || "N",
        price: item.price || 0,
        seq: this.deliveryList.length + 1,
        price_additional: item.price_additional || 0,
      };
      this.onDeliveryPriceChange();
      this.showDeliveryModal = true;
    },
    async delete_delivery(item) {
      if (!confirm('ต้องการลบ "' + item.name + '" ใช่หรือไม่?')) return;
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.post("v1/organizer/event-edit-runner-delivery-type/delete", { event_key: this.$route.params.event_key, id: item.id }, { headers });
      if (res.data.status === "success") {
        await this.load_delivery();
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    onDeliveryPriceChange() {
      if (Number(this.deliveryForm.price) > 0) {
        this.deliveryForm.is_require_address = "Y";
      }
    },
    async save_delivery() {
      if (!this.deliveryForm.name.trim()) { alert("กรุณากรอกชื่อช่องทางการจัดส่ง"); return; }
      if (Number(this.deliveryForm.price) > 0 && this.deliveryForm.is_require_address !== "Y") {
        alert("เมื่อราคามากกว่า 0 จะต้องบังคับกรอกที่อยู่ (เลือก 'Y') เท่านั้น");
        return;
      }
      this.isSavingDelivery = true;
      const headers = { Authorization: "Bearer " + this.token };
      const endpoint = this.isEditDelivery
        ? "v1/organizer/event-edit-runner-delivery-type/update"
        : "v1/organizer/event-edit-runner-delivery-type/add";
      const res = await axios.post(endpoint, { ...this.deliveryForm, event_key: this.$route.params.event_key }, { headers });
      this.isSavingDelivery = false;
      if (res.data.status === "success") {
        this.showDeliveryModal = false;
        await this.load_delivery();
      } else {
        alert("พบข้อผิดพลาด: " + res.data.message);
      }
    },
    async authorization() {
      const data = {
        event_key: this.$route.params.event_key,
      };
      const headers = {
        Authorization: "Bearer " + this.token,
      };
      const res = await axios.post("v1/organizer/authorization", data, { headers });
      if (res.data.status === "success") {
        this.is_authorization = res.data.message.is_authorization;
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: " + res.data.message);
      }
    },
    async load_event_detail() {
      this.is_loading = "Y";
      const headers = {
        Authorization: "Bearer " + this.token,
      };
      const res = await axios.get("v1/organizer/event-edit/" + this.$route.params.event_key, { headers });
      if (res.data.status === "success") {
        // body เป็น object เดี่ยว
        const ev = res.data.body;
        if (!ev) {
          alert("ไม่พบข้อมูลกิจกรรม");
          this.is_loading = "N";
          return;
        }
        // Map ทุก field จาก API เข้า eventForm
        Object.keys(this.eventForm).forEach((key) => {
          if (ev[key] !== undefined && ev[key] !== null) {
            this.eventForm[key] = ev[key];
          }
        });
        // แปลง timestamp เป็น datetime-local format (YYYY-MM-DDTHH:mm)
        if (this.eventForm.registration_start) {
          this.eventForm.registration_start = this.toDatetimeLocal(this.eventForm.registration_start);
        }
        if (this.eventForm.registration_end) {
          this.eventForm.registration_end = this.toDatetimeLocal(this.eventForm.registration_end);
        }
        this.splitRegistrationDateTimes();
        // แปลง event_date เป็น YYYY-MM-DD สำหรับ input type="date"
        if (this.eventForm.event_date) {
          this.eventForm.event_date = this.eventForm.event_date.substring(0, 10);
        }
        this.is_loading = "N";
      } else {
        alert("ไม่พบข้อมูลกิจกรรม[กรุณาแจ้งผู้ดูแลระบบ]: " + (res.data.message || ""));
        this.is_loading = "N";
      }
    },
    toDatetimeLocal(value) {
      if (!value) return "";
      // Convert "YYYY-MM-DD HH:mm:ss" or ISO string to "YYYY-MM-DDTHH:mm"
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        "T" +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
      );
    },
    formatDateDisplay(value) {
      if (!value) return "";
      const parts = value.substring(0, 10).split("-");
      if (parts.length !== 3) return value;
      return parts[2] + "/" + parts[1] + "/" + parts[0];
    },
    formatDatetimeDisplay(value) {
      if (!value) return "";
      const datePart = value.substring(0, 10);
      const timePart = value.length > 10 ? value.substring(11, 16) : "";
      const parts = datePart.split("-");
      if (parts.length !== 3) return value;
      const dateStr = parts[2] + "/" + parts[1] + "/" + parts[0];
      return timePart ? dateStr + " " + timePart : dateStr;
    },
    parseDateTimeValue(value) {
      if (!value) return null;
      const normalized = String(value).replace(" ", "T");
      const date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return null;
      return date;
    },
    getPromotionStatus(item) {
      const start = this.parseDateTimeValue(item.price_promotion_start);
      const end = this.parseDateTimeValue(item.price_promotion_end);
      if (!start || !end) return "unknown";

      const now = new Date();
      if (now > end) return "past";
      if (now >= start && now <= end) return "current";
      return "future";
    },
    getPromotionTextClass(item) {
      const status = this.getPromotionStatus(item);
      if (status === "past") return "text-secondary";
      if (status === "current") return "text-success fw-semibold";
      if (status === "future") return "text-body";
      return "text-muted";
    },
    formatPromotionDisplayText(value, item) {
      if (!value) return "-";
      const text = this.formatDatetimeDisplay(value);
      if (this.getPromotionStatus(item) === "current") {
        return text + " (is showing)";
      }
      return text;
    },
    splitDateTimeParts(value) {
      if (!value) return { date: "", time: "" };
      const normalized = String(value).replace(" ", "T");
      const date = normalized.length >= 10 ? normalized.substring(0, 10) : "";
      const time = normalized.length >= 16 ? normalized.substring(11, 16) : "";
      return { date, time };
    },
    buildDateTime(date, time) {
      if (!date) return "";
      return date + "T" + (time || "00:00");
    },
    splitRegistrationDateTimes() {
      const startParts = this.splitDateTimeParts(this.eventForm.registration_start);
      this.registrationStartDate = startParts.date;
      this.registrationStartTime = startParts.time;

      const endParts = this.splitDateTimeParts(this.eventForm.registration_end);
      this.registrationEndDate = endParts.date;
      this.registrationEndTime = endParts.time;
    },
    onRegistrationStartChange() {
      this.eventForm.registration_start = this.buildDateTime(this.registrationStartDate, this.registrationStartTime);
    },
    onRegistrationEndChange() {
      this.eventForm.registration_end = this.buildDateTime(this.registrationEndDate, this.registrationEndTime);
    },
    downloadThaiContentHtml() {
      const title = this.eventForm.title || "event-content-th";
      const safeTitle = String(title)
        .trim()
        .replace(/[^a-zA-Z0-9ก-๙\s-_]/g, "")
        .replace(/\s+/g, "-")
        .substring(0, 80) || "event-content-th";
      const htmlContent = this.eventForm.content || "";
      const fileContent = htmlContent;

      const blob = new Blob([fileContent], { type: "text/html;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = safeTitle + ".html";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    syncThaiContentToEnglish() {
      this.eventForm.content_en = this.eventForm.content || "";
    },
    async save_event() {
      if (!this.eventForm.title) {
        alert("กรุณากรอกชื่อกิจกรรม");
        return;
      }
      if (!this.eventForm.event_date) {
        alert("กรุณากรอกวันที่จัดกิจกรรม");
        return;
      }
      this.onRegistrationStartChange();
      this.onRegistrationEndChange();
      this.is_saving = "Y";
      const headers = {
        Authorization: "Bearer " + this.token,
      };
      const data = {
        ...this.eventForm,
        event_key: this.$route.params.event_key,
      };
      const res = await axios.post("v1/organizer/update-event", data, { headers });
      if (res.data.status === "success") {
        alert("บันทึกข้อมูลสำเร็จ");
        this.is_saving = "N";
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: " + res.data.message);
        this.is_saving = "N";
      }
    },
  },
};
</script>
